const INITIAL_ARTERIA = {
  direita: {
    arteriaVertebral: { velSistolica: '', velDiastolica: '' },
    arteriaCarotidaExterna: { velSistolica: '', velDiastolica: '' },
    arteriaCarotidaInterna: { velSistolica: '', velDiastolica: '' },
    arteriaCarotidaComum: { velSistolica: '', velDiastolica: '' },
  },
  esquerda: {
    arteriaVertebral: { velSistolica: '', velDiastolica: '' },
    arteriaCarotidaExterna: { velSistolica: '', velDiastolica: '' },
    arteriaCarotidaInterna: { velSistolica: '', velDiastolica: '' },
    arteriaCarotidaComum: { velSistolica: '', velDiastolica: '' },
  },
  razaoDireita: '',
  razaoEsquerda: '',
};

function parseImagem(raw) {
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
}

function razaoCiCc(interna, comum) {
  if (interna === '' || comum === '' || interna == null || comum == null) {
    return null;
  }

  const velInterna = Number(String(interna).replace(',', '.'));
  const velComum = Number(String(comum).replace(',', '.'));
  if (
    !Number.isFinite(velInterna) ||
    !Number.isFinite(velComum) ||
    velComum === 0
  ) {
    return null;
  }

  return velInterna / velComum;
}

function formatRazao(value) {
  if (!Number.isFinite(value)) return '';
  return value.toFixed(1);
}

export { INITIAL_ARTERIA, parseImagem, razaoCiCc, formatRazao };
